<app-list-layout-with-routing [Path]="PageMetaMaterial.Path" TabLabel="Materialien">
    <mat-drawer-container>
        <mat-drawer #drawer position="end">
            <app-table-config-form [columns]="TableColumnsSorted$ | async" [selectedColumns]="selectedColumns$ | async" (selectedColumnsChange)="selectedColumnsChange($event)"></app-table-config-form>
        </mat-drawer>
        <mat-drawer-content class="flex flex-col">
            <div class="grow">
                <div class="loading-shade" *ngIf="PageIsLoading$ | async">
                    <mat-spinner></mat-spinner>
                </div>
                <app-dave-list
                    [ColumnConfig]="TableColumns"
                    [Columns]="selectedColumns$ | async"
                    (ColumnsChange)="selectedColumnsChange($event)"
                    (SortChange)="sortChange($event)"
                    (SearchChange)="searchChange($event)"
                    [ColumnsSmall]="selectedColumns$ | async"
                    [DataSource$]="MaterialDataSource$"
                    [Headline]="PageMetaMaterial.Breadcrumb"
                    [HeadlineIcon]="PageMetaMaterial.Icon"
                    [NewEntryUrl]="'./' + NewMaterialPageMeta.Path"
                    NewEntryToolTip="Material Hinzufügen"
                    [EmptyText]="'Keine ' + PageMetaMaterial.Breadcrumb + ' Vorhanden'"
                    [FilterValues]="FilterValues$ | async"
                    (FilterValuesChange)="FilterValues$.next($event)"
                    [FilterSettings]="FilterSettings$ | async"
                    [preventSort]="true"
                    [disableSort]="!!(searchChange$ | async)"
                >
                    <ng-container *appDetailViewButtons>
                        <button app-round-button (click)="onAddWarehouseMovement()" matTooltip="Wareneingang anlegen" Inverted style="margin: 0.25rem">
                            <app-double-icon Icon="warehouse" Icon2="up-right-and-down-left-from-center"></app-double-icon>
                        </button>

                        <button app-round-button (click)="onDatanormClick()" matTooltip="Datanorm V4/V5 importieren" Inverted style="margin: 0.25rem"><fa-icon icon="upload"></fa-icon></button>
                        <button class="header-button" app-round-button Inverted [matBadge]="disabledColumns$ | async" matTooltip="Tabelle anpassen" matTooltipPosition="left" (click)="drawer.toggle()">
                            <fa-icon icon="cog"></fa-icon>
                        </button>
                    </ng-container>
                </app-dave-list>
            </div>
            <mat-paginator [class.limit-reached]="countLimitReached$ | async" class="material-list-view-paginator" [pageSize]="pageSize$ | async" [length]="length$ | async"></mat-paginator>
        </mat-drawer-content>
    </mat-drawer-container>
</app-list-layout-with-routing>
